<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="top-bar">
      <span @click="goBack">
        <i class="left"></i>
      </span>
      <span class="heading_new">{{headerName}} Salary</span>
      <span class="spacer" />
    </div>
    <section class="singleColumnGrid main-container">
      <selected-employee-card
        :empName="employeeData.name"
        :empId="employeeData.code"
        :closable="false"
        :empMail="employeeData.email_id"
      ></selected-employee-card>
      <div>
        <span class="input-label">Effective Date</span>
        <date-picker
          class="customwidth"
          :initialView="'month'"
          :formatDate="'MMM/yyyy'"
          :maximumView="'year'"
          :minimumView="'month'"
          :datesDisabled="{to:currentDate}"
          @datevalue="(val)=> {effectiveDate=val; getDAteValue(val)}"
          :value="effectiveDate"
        />
      </div>
      <div>
        <div class="lop" v-if="displaylop">
          <div>LOP</div>
          <div class="filters">
            <tl-select
              class="custom-width"
              label="Select Days/Dates"
              :placeholder="'Select'"
              :options="lopSelect"
              @change="(val)=>filtertype=val"
            ></tl-select>
            <div v-if="filtertype == 'Date/s'">
              <span class="input-label">Date/s</span>
              <date-picker
                class="customwidth"
                @datevalue="(val)=>setCustomDate(val)"
                :datesDisabled="{from:new Date(),to: new Date(this.effectiveDate)}"
                :value="salaryReleaseDate"
                :v-model="salaryReleaseDate"
              />
              <span v-if="salaryReleaseDate">
                <b>Selected Dates:{{salaryReleaseDate}}</b>
              </span>
            </div>
          </div>
          <data-table
            class="margintop-20"
            v-if="filtertype == 'No. of Days'"
            :columns="columnNames"
            :tableData="lopData"
            :checkbox="false"
            :showinrow="false"
          >
            <template v-slot:rowcontent="slotprops">
              <p
                v-if="slotprops.value.column.key=='month'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key=='no_of_lop'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <div class="inc-dec-bar" v-if="slotprops.value.column.key=='noofdays'">
                <img
                  class="inc"
                  src="@/assets/stroke-1-copy.svg"
                  @click="increase(slotprops.value.index)"
                />
                <p>{{slotprops.value.record[slotprops.value.column.key]}}</p>
                <img
                  class="dec"
                  src="@/assets/stroke-1-copy.svg"
                  @click="decrease(slotprops.value.index)"
                />
              </div>
            </template>
          </data-table>
        </div>
      </div>
      <txt
        class="customwidth"
        label="Reason"
        name="reason"
        type="textarea"
        rows="4"
        v-model="reason"
      />
      <tl-checkbox label="Stop IT Projection" name="it_projection" v-model="it_projection" />
      <pop-up-message
        v-if="showSuccessMsg"
        :message="msgText"
        btnText="Back To Hold, Release and Stop Salary"
        @back="goBackTo"
      ></pop-up-message>
      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="goBack" />
            <btn :text="bottomBtnText" type="primary" @click="holdSalary" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </section>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
import { monthOptionsObj } from "../../../../../../../apis/constants.js";
export default {
  components: {
    SelectedEmployeeCard
  },
  data() {
    return {
      bottomBtnText: "",
      employeeData: {},
      effectiveDate: "",
      financialMonthOptions: monthOptionsObj.monthListForFinancialYear,
      monthNames: monthOptionsObj.onlyMonths,
      it_projection: false,
      reason: "",
      msgText: "",
      lopData: [],
      toast: false,
      columnNames: [
        {
          label: "Month",
          key: "month"
        },
        {
          label: "LOPs",
          key: "no_of_lop"
        },
        {
          label: "No. of Days",
          key: "noofdays"
        }
      ],
      lopSelect: ["No. of Days", "Date/s"],
      showSuccessMsg: false,
      headerName: "",
      errmsg: "",
      displaylop: false,
      currentDate: null,
      filtertype: "",
      current_salary_obj: {},
      salaryReleaseDate: null
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      employeeObj: "dashboard/payroll/utilities/holdsalary/record",
      statustype: "dashboard/payroll/utilities/holdsalary/status"
    }),
    ...mapState({
      heldemp: state => state.dashboard.payroll.utilities.holdsalary,
      userName: state => state.auth.employeeId
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  mounted() {
    this.getSalaryDetails();
    this.getLopData();
  },
  activated() {
    this.resetForm();
    this.getSalaryDetails();
    this.getLopData();
  },
  methods: {
    ...mapActions({
      hold_release_stop:
        "dashboard/payroll/utilities/holdsalary/holdReleaseAndStop",
      act_fetchlop: "dashboard/payroll/utilities/uploadloprlop/fetchLOPsByEmp"
    }),

    /* function to go back to employee list */
    goBack() {
      this.showSuccessMsg = false;
      this.$router.push(
        `/dashboard/${this.$route.params.entity_index}/payroll/utilities/hold_release_salary`
      );
    },

    /* function to reset form */
    resetForm() {
      this.effectiveDate = "";
      this.it_projection = false;
      this.reason = "";
    },

    /* function to increase lop count */
    increase(index) {
      try {
        this.lopData[index].no_of_lop += 0.5;
        this.lopData[index].noofdays += 0.5;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to dcrease lop count */
    decrease(index) {
      try {
        if (this.lopData[index].no_of_lop) {
          this.lopData[index].no_of_lop -= 0.5;
          this.lopData[index].noofdays -= 0.5;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server to get lop data of employee */
    async getLopData() {
      try {
        let res = await this.act_fetchlop(this.employeeObj.id);
        let d = new Date();
        let currentMonth = d.getMonth();
        this.lopData = [];
        this.rlopData = [];
        let index = this.financialMonthOptions.findIndex(
          item => item.name == this.monthNames[currentMonth]
        );
        let monthList = this.financialMonthOptions.slice(0, index + 1);
        monthList.forEach(element => {
          let obj = res.data.payload.length
            ? res.data.payload[0].no_of_lop_days[element.value]
            : 0;
          this.lopData.push({
            no_of_lop: obj ? obj : 0,
            lop_days: res.data.payload.length
              ? res.data.payload[0].lop_days
              : [],
            month_name: element.name,
            month: element.value,
            financial_year: 2019,
            noofdays: 0
          });
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get salary details of employee */
    getSalaryDetails() {
      try {
        let d = new Date();
        if (this.employeeObj) {
          this.employeeData = this.employeeObj;
          if (this.employeeObj.EmployeeSalaryInstructions.length) {
            this.effectiveDate = this.employeeObj.EmployeeSalaryInstructions[0].effective_date;
            this.reason = this.employeeObj.EmployeeSalaryInstructions[0].reason;
            this.it_projection = this.employeeObj.EmployeeSalaryInstructions[0].stop_it_projection;
            this.current_salary_obj = this.employeeObj.EmployeeSalaryInstructions.find(
              item => item.current_status
            );
          }
        }
        if (this.statustype == "release") {
          this.headerName = "Release";
          this.bottomBtnText = "Release";
          this.currentDate = null;
        } else if (this.statustype == "hold") {
          this.headerName = "Hold";
          this.bottomBtnText = "Hold";
          this.currentDate = new Date(d.setDate(d.getDate() - 1));
        } else {
          this.headerName = "Stop";
          this.bottomBtnText = "Stop";
          this.currentDate = new Date(d.setDate(d.getDate() - 1));
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set success message */
    setSuccessMsg() {
      try {
        switch (this.statustype) {
          case "release":
            this.msgText = "salary released Successfully";
            break;
          case "hold":
            this.msgText = "salary holded Successfully";
            break;
          case "stop":
            this.msgText = "salary stopped Sucessfully";
            break;
          default:
            break;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set custom date */
    setCustomDate(event) {
      try {
        this.salaryReleaseDate =
          new Date(event).getDate() +
          "/" +
          this.monthNames[new Date(event).getMonth()].slice(0,3) +
          "/" +
          new Date(event).getFullYear();
        return this.salaryReleaseDate == "NaN/undefined/NaN"
          ? ""
          : this.salaryReleaseDate;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to submit details */
    async holdSalary() {
      try {
        let salaryStatus = "";
        let releaseDates = [];
        if (this.statustype == "hold") {
          salaryStatus = "hold_salary";
        } else if (this.statustype == "release") {
          salaryStatus = "normal";
        } else {
          salaryStatus = "stop_salary";
        }
        let lopObj = {
          lop_days: [this.salaryReleaseDate],
          month: this.monthNames[new Date(this.salaryReleaseDate).getMonth()].slice(0,3),
          financial_year: new Date(this.salaryReleaseDate).getFullYear(),
          employee_id: this.employeeObj.id
        };
        let obj = {
          employee_id: this.employeeObj.id,
          legal_entity_id: this.le_id,
          effective_date: this.setFormatDate(this.effectiveDate),
          stop_it_projection: this.it_projection ? this.it_projection : false,
          reason: this.reason,
          current_salary_status: salaryStatus,
          date_created: new Date().getMonth() + "/" + new Date().getFullYear(),
          updated_on: new Date().getMonth() + "/" + new Date().getFullYear(),
          created_by: this.employeeObj.id,
          Lops: lopObj ? [lopObj] : []
        };
        let res = await this.hold_release_stop({ data: obj });
        if (res.data.status) {
          this.showSuccessMsg = true;
          this.setSuccessMsg();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    // function to close popup
    releaseSalary() {
      this.showSuccessMsg = true;
    },

    /* function to set date format */
    setFormatDate(event) {
      return new Date(event).getMonth() + "/" + new Date(event).getFullYear();
    },

    /* function to hide and show lop section */
    getDAteValue(event) {
      try {
        this.salaryReleaseDate = "";
        if (this.employeeObj.EmployeeSalaryInstructions.length) {
          if (
            this.current_salary_obj.current_salary_status == "stop_salary" &&
            this.statustype == "release" &&
            new Date(event) < new Date()
          ) {
            this.displaylop = true;
          } else {
            this.displaylop = false;
          }
        } else {
          this.displaylop = false;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to go to back to previous page */
    goBackTo() {
      this.showSuccessMsg = false;
      this.$router.go(-1);
    }
  }
};
</script>



<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
.inc-dec-bar {
  width: 110px;
  height: 35px;
  display: flex;
  border-radius: 4px;
  border: solid 1px #dadada;
  background-color: #ffffff;
  img.inc {
    padding: 12px 10px 10px 10px;
    min-width: 32px;
    height: 35px;
    border-radius: 4px;
    border: solid 1px #34c0be;
    cursor: pointer;
  }
  img.dec {
    padding: 12px 10px 10px 10px;
    cursor: pointer;
    min-width: 32px;
    height: 35px;
    border-radius: 4px;
    border: solid 1px #34c0be;
  }
  p {
    padding: 8px 0 0 10px;
  }
}
.refresh-icon {
  cursor: pointer;
}
.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.customwidth {
  width: 300px;
}
.close-card {
  display: none;
}
</style>
